
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/diamondhead/reservation-details",
      function () {
        return require("private-next-pages/diamondhead/reservation-details.js");
      }
    ]);
  